//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  insertOtherSpecial,
  querySpecialConfigInfo,
} from '@/https/otherApplication'
import TDynamicForm from '@/TShareComponent/TDynamicForm'
import {
  danger,
  success,
} from '@/utils/notify'
import { SAVE_SUCCESS } from '@/constant/tips'
import attachmentDetail from '../../enroll/attachment/attachmentDetail'
import attachmentInfo from './TSpecialAttachment'

export default {
  components: {
    TDynamicForm,
    attachmentInfo,
    attachmentDetail,
  },

  props: {
    showFooter: {
      type: Boolean,
      default: true,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      loading: false,
      applicationConfigAllData: {},
      formData: {},
    }
  },

  computed: {
    showApply () {
      return this.applicationConfigAllData?.bmqsfktbtssq === '1' || this.applicationConfigAllData?.ksxxItem?.ksWid
    },
  },

  created () {
    this.setConfigList()
  },

  methods: {
    back () {
      this.$emit('on-change-component', 'TSpecialNotice')
    },

    async handlerSave () {
      if (!await this.$refs.formDom.validate()) {
        return
      }

      const result = await this.$refs.attachment.filterSaveParams()

      if (!result.validate) {
        return
      }

      const baseInfo = {}

      Object.keys(this.formData).forEach((key) => {
        const value = this.formData[key]

        if (value instanceof Array) {
          if (value[0].url) {
            baseInfo[key] = value.map((el) => el.url).join(',')
          } else {
            baseInfo[key] = value.join(',')
          }
        } else {
          baseInfo[key] = value
        }
      })

      this.loading = true
      const data = await insertOtherSpecial({
        ksxxItem: { ...baseInfo },
        ...result.params,
      })

      this.loading = false

      if (data.code === 0) {
        success(data.message || SAVE_SUCCESS)
        this.$router.go(-1)
      } else {
        danger(data.message || '报名失败')
      }
    },

    async setConfigList () {
      this.loading = true
      const { tssqWid, code, pcdm } = this.$route.query

      const { data } = await querySpecialConfigInfo({
        tssqWid,
        pcdm,
        tssqlxdm: code,
      })

      this.applicationConfigAllData = data || {}
      this.loading = false
    },
  },
}
